<div id="main-content">
    <div class="container-fluid">
        <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="p-4">
            <h4>Settlement Preview</h4>
            <small *ngIf="loadingSettlement">Loading Range</small>
            <small *ngIf="!loadingSettlement">Range: {{ticketRange.from}} - {{ticketRange.to}}</small>
            <div class="container pt-5">
              <div class="row">
                <div class="card shadow-lg d-flex flex-column align-items-start justify-content-between py-2 col mr-1" style="height: 100px;">
                  <strong>Total ticketing</strong>
                  <h2>&#8358;{{ loadingSettlement ? '--' : ticketSummary.total_ticketing}}</h2>
                </div>
                <div class="card shadow-lg d-flex flex-column align-items-start justify-content-between py-2 col" style="height: 100px;">
                  <strong>Total Remitted</strong>
                  <h2>&#8358;{{ loadingSettlement ? '--' : ticketSummary.total_remitted}}</h2>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-end p-4" style="gap: 10px;">
            <form [formGroup]="filterForm" (ngSubmit)="onFilterForm()" class="d-flex align-items-center justify-content-end flex-wrap" style="gap: 10px;" >
              <div>
                <label for="start">Start Date</label>
                <input id="start" formControlName="from" type="date" class="form-control">
              </div>
              <div>
                <label for="end">End Date</label>
                <input id="end" formControlName="to" type="date" class="form-control">
              </div>
              <div class="d-flex align-items-center align-self-end" style="gap: 10px">
                <button type="submit" [disabled]="filterForm.invalid || loadingSettlement"  class="btn btn-primary">
                  Filter
                </button>
                <button type="button" class="btn btn-danger" (click)="onReset()">
                  Reset
                </button>
              </div>
            </form>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingSettlement"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="changeOccured">
              <table id="all-state-zones" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th class="no-sort" width="5%"></th>
                  <th>S/N</th>
                  <th>Zone</th>
                  <th>Category</th>
                  <th>Amount</th>
                  <th>Account Number</th>
                  <th>Account Name</th>
                  <th>Bank Name</th>
                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th class="no-sort"></th>
                  <th>S/N</th>
                  <th>Zone</th>
                  <th>Category</th>
                  <th>Amount</th>
                  <th>Account Number</th>
                  <th>Account Name</th>
                  <th>Bank Name</th>
                </tr>
                </tfoot>
                <tbody>
                <tr *ngFor="let agent of settlements;let i = index;">

                  <td class="details-control" [id]="'td-' + i" ></td>
                  <td>{{ i + 1 }}</td>
                 <td>{{ agent?.zone_name | titlecase }}</td>
                 <td>{{ agent?.category | titlecase }}</td>

                  <td>{{ agent?.amount || 0 | currency: '&#8358;' }}</td>
                  <td>{{ agent?.account_number || '--' }}</td>
                  <td>{{ agent?.account_name || '--' }}</td>
                  <td>{{ agent?.bank_name || '--' }}</td>

                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
</div>
